export default "__VITE_ASSET__4mQu3oTo__"